import { z } from "zod";

// TODO: Copied (partially)from firebase/lmt/src/common/types. Replace the file there with imports from this file and move tests if any.

export const MemberSatisfactionOptions: readonly [string, ...string[]] = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
];
export const MemberSatisfaction = z.enum(MemberSatisfactionOptions);
export type MemberSatisfaction = z.infer<typeof MemberSatisfaction>;
